
import { useNavigate } from 'react-router-dom';

export default function LearnTeaser() {
  const navigate = useNavigate();

  return (
    <section className="w-full bg-white py-16 md:py-24 px-4 md:px-8 lg:px-16">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          {/* Left side - Image */}
          <div className="w-full md:w-1/2">
            <div className="relative w-full h-[300px] md:h-[400px] rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/fd796c9c54e0e7923121dee148e0b65f.jpg"
                alt="Learn from the Pros"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="flex items-center gap-3 text-white">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-[#F2C612] rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-transform duration-300">
                    <i className="ri-play-fill text-[#1A1A1A] text-[24px] md:text-[28px]"></i>
                  </div>
                  <span
                    className="text-[16px] md:text-[18px] font-semibold"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    Watch: How to Tile a Floor
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Right side - Content */}
          <div className="w-full md:w-1/2">
            <h2
              className="text-[32px] md:text-[42px] font-bold text-[#1A1A1A] mb-4 md:mb-6"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Learn from the Pros
            </h2>
            <p
              className="text-[16px] md:text-[18px] text-[#666666] leading-relaxed mb-6 md:mb-8"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Step-by-step video guides for tiling, grouting, painting, and more. Whether you're a DIY beginner or a seasoned contractor, our tutorials help you get the job done right.
            </p>
            <ul className="space-y-3 md:space-y-4 mb-6 md:mb-8">
              <li className="flex items-start">
                <i className="ri-check-line text-[#F2C612] text-[22px] md:text-[24px] mr-3 mt-1"></i>
                <span className="text-[15px] md:text-[16px] text-[#333333]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Professional techniques explained simply
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#F2C612] text-[22px] md:text-[24px] mr-3 mt-1"></i>
                <span className="text-[15px] md:text-[16px] text-[#333333]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Product recommendations for each project
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-[#F2C612] text-[22px] md:text-[24px] mr-3 mt-1"></i>
                <span className="text-[15px] md:text-[16px] text-[#333333]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                  Common mistakes to avoid
                </span>
              </li>
            </ul>
            <button
              onClick={() => navigate('/learn')}
              className="bg-[#F2C612] text-[#1A1A1A] px-8 py-4 rounded text-[16px] font-semibold hover:shadow-lg transition-all duration-300 hover:-translate-y-1 whitespace-nowrap cursor-pointer w-full md:w-auto h-[58px] flex items-center justify-center"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              View All Tutorials
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}